import { Link } from "react-router-dom";
import { MdEvent } from "react-icons/md";
import { MdLocationOn } from "react-icons/md";
import { FaMicrophone } from "react-icons/fa";
import { FaHandshake } from "react-icons/fa";
import { FaStore } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { MdEventNote } from "react-icons/md";
import { MdMeetingRoom } from "react-icons/md";

// This component renders a sidebar for the Event Dashboard page.
//  It renders a series of links to different sections of the page and highlights the active section.
const SideBar = ({ activeSection, handleActive }) => {
  return (
    <div className="sidebar">
      <div
        className={`section ${activeSection === "main-event" ? "active" : ""}`}
        onClick={() => handleActive("main-event")}
      >
        <MdEvent className="icon" />
        <Link to="main-event">Main Event</Link>
      </div>
      <div
        className={`section ${activeSection === "location" ? "active" : ""}`}
        onClick={() => handleActive("location")}
      >
        <MdLocationOn className="icon" />
        <Link to="location">Location Details</Link>
      </div>
      <div
        className={`section ${activeSection === "speakers" ? "active" : ""}`}
        onClick={() => handleActive("speakers")}
      >
        <FaMicrophone className="icon" />
        <Link to="speakers">List of Speakers</Link>
      </div>
      <div
        className={`section ${activeSection === "sponsor" ? "active" : ""}`}
        onClick={() => handleActive("sponsor")}
      >
        <FaHandshake className="icon" />
        <Link to="sponsor">List of Sponser</Link>
      </div>
      <div
        className={`section ${activeSection === "stalls" ? "active" : ""}`}
        onClick={() => handleActive("stalls")}
      >
        <FaStore className="icon" />
        <Link to="stalls">List of Stalls</Link>
      </div>
      <div
        className={`section ${activeSection === "agenda" ? "active" : ""}`}
        onClick={() => handleActive("agenda")}
      >
        <MdEventNote className="icon" />
        <Link to="agenda">Agenda</Link>
      </div>
      <div
        className={`section ${
          activeSection === "registration" ? "active" : ""
        }`}
        onClick={() => handleActive("registration")}
      >
        <FaUser className="icon" />
        <Link to="registration">Registration</Link>
      </div>
      <div
        className={`section ${activeSection === "meetings" ? "active" : ""}`}
        onClick={() => handleActive("meetings")}
      >
        <MdMeetingRoom className="icon" />
        <Link to="registration">Meeting Room</Link>
      </div>
    </div>
  );
};

export default SideBar;
